<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer></v-spacer>
      <div class="d-flex justify-end">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              x-small
              fab
              depressed
              color="primary"
              v-on="on"
              @click="createDialog = true">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>
            Agregar proveedor
          </span>
        </v-tooltip>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        sort-by="name"
        :footer-props="{
          'items-per-page-options': [25, 50]
        }"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3">
            <v-row>
              <v-col cols="12">
                <v-switch
                  @change="isEnableProvider"
                  v-model="isEnable"
                  inset
                  color="primary"
                  :label="isEnable ? 'ACTIVADO' : 'DESACTIVADO'"
                />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex align-center">
            <v-tooltip left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="error"
                  v-on="on"
                  @click="deleteProvider(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar proveedor</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog @keydown.esc="createDialog=false" v-model="createDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar proveedor</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="userForm">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex>
                  <v-autocomplete
                    :value="providerSelected"
                    :items="searchProvider.items"
                    :loading="searchProvider.isLoading"
                    :search-input.sync="searchProvider.search"
                    outlined
                    rounded
                    color="primary"
                    hide-details
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="_id"
                    placeholder="Buscar proveedor"
                    @change="selectProvider"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="onCloseCreateDialog">Cancelar</v-btn>
          <v-btn :disabled="!providerSelected" color="blue darken-1" text @click="submit">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'Providers',
  data () {
    return {
      section: 'Proveedores Permitidos',
      createDialog: false,
      search: '',
      providers: [],
      isEnable: false,
      overlay: false,
      allowedProviders: [],
      table: {
        title: 'Loading providers',
        loading: false,
        data: [],
        selected: [],
        total: 0,
        headers: [
          { text: 'Proveedor', value: 'provider.name' },
          { text: 'Action', value: 'action' }
        ],
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      searchProvider: {
        search: '',
        selected: null,
        items: [],
        isLoading: false
      },
      providerSelected: null
    }
  },
  async mounted () {
    await this.load()
  },
  watch: {
    'searchProvider.search': debounce(async function (val) {
      this.searchProvider.isLoading = true
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        fetchAll: true,
        name: `/${val}/i`
      }
      try {
        const providers = await this.$api.get('/v1/providers', params)
        const filterProvider = providers.data.filter(item => !this.table.data.find(x => x.provider._id === item._id))
        this.searchProvider.items = filterProvider
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.searchProvider.isLoading = false
    }, 600)
  },
  methods: {
    onCloseCreateDialog () {
      this.providerSelected = null
      this.createDialog = false
    },
    selectProvider (provider) {
      this.providerSelected = provider
    },
    async isEnableProvider  () {
      this.overlay = true
      try {
        await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`, { useWhiteList: this.isEnable })
        this.isEnable
          ? this.$toasted.show('Se ha activado la busqueda en las ordenes de compra', { duration: 3000 })
          : this.$toasted.show('Se ha desactivado la busqueda en las ordenes de compra', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async load () {
      this.table.loading = true
      try {
        const restaurant = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`)
        this.isEnable = restaurant.useWhiteList
        this.allowedProviders = restaurant.allowedProviders.map(prov => ({ provider: prov.provider._id }))
        this.table.data = restaurant.allowedProviders
        this.table.total = restaurant.allowedProviders.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    submit: async function () {
      this.overlay = true
      const payload = {}
      try {
        payload.allowedProviders = this.allowedProviders
        payload.allowedProviders.push({ provider: this.providerSelected })
        await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`, payload)
        await this.load()
        this.onCloseCreateDialog()
        this.$toasted.show('Se ha agregado el proveedor correctamente', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async deleteProvider (prov) {
      this.overlay = true
      try {
        const allowedProviders = this.allowedProviders
        const index = allowedProviders.findIndex(x => x.provider === prov.provider._id)
        allowedProviders.splice(index, 1)
        await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}`, { allowedProviders: allowedProviders })
        await this.load()
        this.onCloseCreateDialog()
        this.$toasted.show('Se ha eliminado el proveedor correctamente', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
